import { FormField, Icon } from '@acast/decibel';
import { PencilRegularGlyph, UndoLightGlyph } from '@acast/decibel-glyphs';
import React from 'react';

const createRenderToggleDisabled = (attachToDescription, detachFromDescription) => disabled => {
  const text = disabled ? 'Edit' : 'Use description';
  const glyph = disabled ? PencilRegularGlyph : UndoLightGlyph;

  return (
    <FormField.Action
      onClick={() => {
        if (disabled) {
          detachFromDescription();
        } else {
          attachToDescription();
        }
      }}
    >
      <Icon glyph={glyph} size="1em" mr={1} />
      <span>{text}</span>
    </FormField.Action>
  );
};

export default createRenderToggleDisabled;
